/**
 * Работа с файлами
 */

;
window.FK = (() => {
	"use strict";

	const FK = {
		/**
		 * Форматирует размер файла в человекочитаемый вид
		 */
		formatFileSize(bytes) {
			if (!bytes || bytes === 0)
				return '0 Кб';
			const kb = (bytes / 1024).toFixed(1);
			return `${kb} Кб`;
		},

		/**
		 * Форматирует размер файла 
		 * @param {type} a
		 * @param {type} b
		 * @returns {String}
		 */
		formatBytes(a, b) {
			if (0 == a) {
				return "0 байт";
			}

			var c = 1024, d = b || 2, e = ['байт', 'Kб', 'Мб', 'Гб', 'Тб'], f = Math.floor(Math.log(a) / Math.log(c));
			return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f]
		},

		getStrFileSize(size) {
			return `[${FK.formatFileSize(size)}]`;
		},

		/**
		 * Узнать расширение файла
		 * @param {type} name - полное название файла в строковом формате
		 * @returns {FK=>#5.FK.getFileInfoFromName.result}
		 */
		getFileExtension(name) {
			const re = /(?:\.([^.]+))?$/;
			let ext = re.exec(name)[1].toLowerCase();
			let result = {
				ext: ext,
				type: void 0,
				gosKeyAllowed: false,
				fileExtChange: false
			};
			let type = null;
			if (ext === "jpeg") {
				ext = "jpg";
			}
			switch (ext) {
				case "docx":
					type = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
					break;
				case "xlsx":
					type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
					break;
				case "pdf":
					type = "application/pdf";
					break;
				case "png":
					type = "image/png";
					break;
				case "txt":
				case "html":
					type = "text/plain";
					break;
				case "jpeg":
				case "jpg":
					type = "image/jpeg";
					break;
				case "zip":
					type = "application/zip";
					break;
				case "rar":
					type = "application/rar";
					break;
				default:
					type = null;
					break;
			}
			result.type = type;
			result.gosKeyAllowed = PARAMS.goskey_allowed_ext.includes(ext) || PARAMS.goskey_allowed_ext_for_change.includes(ext);
			result.fileExtChange = PARAMS.goskey_allowed_ext_for_change.includes(ext);
			return result;
		},

		/**
		 * Узнать допустимые расширения файлов
		 */
		getAcceptableFileExtension(useDot = false, concatenate = false) {
			if (PARAMS.isUseGosKey) {
				let ext = PARAMS.goskey_allowed_ext;

				if (PARAMS.goskey_allowed_ext_for_change.length > 0) {
					ext = [...ext, PARAMS.goskey_allowed_ext_for_change];
				}
				if (useDot) {
					ext = ext.map(e => "." + e);
				}
				if (concatenate) {
					ext = ext.join(", ");
				}

				return ext;
			} else {
				let ext = PARAMS.valid_file_extensions;

				if (useDot) {
					ext = ext.map(e => "." + e);
				}
				if (concatenate) {
					ext = ext.join(", ");
				}

				return ext;
		}
		},
		
	};
	
	const videoKit = {
		extensions: [
			'avi', 'divx', 'flv', 'm4v', 'mkv', 'mov',
			'mp4', 'mpeg', 'mpg', 'ogm', 'ogv', 'ogx',
			'rm', 'rmvb', 'smil', 'webm', 'wmv', 'xvid'
		],
		
		/**
		 * Проверка файла на видео расширение
		 * @param {string} filename - имя файла
		 * @returns {boolean} true если файл является видео
		 */
		isVideoFile(filename) {
			const ext = filename.split('.').pop().toLowerCase();
			return this.extensions.includes(ext);
		},

		/**
		 * Получить список допустимых видео расширений
		 * @param {boolean} withDot - добавлять ли точку перед расширением
		 * @returns {string[]} массив расширений
		 */
		getVideoExtensions(withDot = false) {
			return withDot ? this.extensions.map(ext => '.' + ext) : extensions;
		},
	}

	const FileUploadKit = (() => {
		"use strict";

		const CONFIG = {
			MAX_FILE_SIZE_MB: 25,
			MAX_BATCH_SIZE_MB: 50,
			TIMEOUT_MS: 30000,
			API_URL: 'fileUpload'
		};

		const STATUS = {
			PENDING: 'pending',
			LOADING: 'loading',
			DONE: 'done',
			ERROR: 'error'
		};

		return {
			/**
			 * Загрузка файлов на сервер // - не используется. нужно доработать
			 * @param {FileList|File[]} files
			 * @param {Object} options - { isImage, isPdf, onProgress }
			 * @returns {Promise<{success: boolean, data?: Array, error?: string}>}
			 */
			async upload(files, options = {}) {
				const {isImage = false, isPdf = false, onProgress} = options;

				const formData = new FormData();
				if (isImage)
					formData.append('img', 'true');
				if (isPdf)
					formData.append('pdf', 'true');

				let totalSize = 0;
				for (let i = 0; i < files.length; i++) {
					const file = files[i];
					if (file.size > CONFIG.MAX_FILE_SIZE_MB * 1024 * 1024) {
						return {success: false, error: `Размер файла должен быть не больше ${CONFIG.MAX_FILE_SIZE_MB} Мб!`};
					}
					totalSize += file.size;
					formData.append(i, file);
				}

				if (totalSize >= CONFIG.MAX_BATCH_SIZE_MB * 1024 * 1024) {
					return {success: false, error: 'Размер загружаемых файлов должен быть менее 50 Мб!'};
				}

				try {
					const xhr = new XMLHttpRequest();

					const result = await new Promise((resolve, reject) => {
						xhr.open('POST', CONFIG.API_URL, true);

						if (onProgress) {
							xhr.upload.addEventListener('progress', (e) => {
								if (e.lengthComputable) {
									onProgress({loaded: e.loaded, total: e.total, percent: Math.round((e.loaded / e.total) * 100)});
								}
							});
						}

						xhr.onload = () => {
							if (xhr.status >= 200 && xhr.status < 300) {
								try {
									resolve({success: true, data: JSON.parse(xhr.responseText)});
								} catch (e) {
									reject(new Error('Ошибка парсинга ответа'));
								}
							} else {
								reject(new Error(`HTTP ${xhr.status}`));
							}
						};

						xhr.onerror = () => reject(new Error('Сетевая ошибка'));
						xhr.send(formData);
					});

					return result;
				} catch (e) {
					return {success: false, error: e.message};
			}
			},

			/**
			 * Валидация файлов перед загрузкой //  - не используется. нужно доработать
			 */
			validateFiles(files, accept) {
				const acceptArr = accept.toLowerCase().replace(/\./g, '').replace(/ /g, '').split(',');

				for (const file of files) {
					const ext = file.name.split('.').pop().toLowerCase();
					if (!acceptArr.includes(ext) && acceptArr[0] !== '*') {
						return {valid: false, error: `Недопустимый тип файла - '${file.name}'!`};
					}
					if (file.size > CONFIG.MAX_FILE_SIZE_MB * 1024 * 1024) {
						return {valid: false, error: `Размер файла должен быть не больше ${CONFIG.MAX_FILE_SIZE_MB} Мб!`};
					}
				}
				return {valid: true};
			},
		}
	})();

	// legacy
	const filesForm = {
		/**
		 * Поворот изображения на 90 градусов по часовой стрелке (если право) и на 90 градусов против часовой стрелки (если лево).
		 * Обновляет CSS-transform для превью и значение скрытого input[name^='rotate'].
		 * @param {HTMLElement} inp - Кнопка поворота, по которой кликнули.
		 */
		rotateImg(inp, side) {
			const SIDES = ['left', 'right'];
			if (!SIDES.includes(side)) {
				console.error("такой стороны нет");
				return;
			}

			const attfile = findParentByClassName(inp, 'attfile');
			const pic = $(".pic", attfile)[0];

			let rotate_val = parseInt($("input[name^='rotate']", attfile).val());
			if (isNaN(rotate_val)) {
				rotate_val = 0;
			}

			let rotate_init_val = parseInt($("input[name^='rotate']", attfile).attr("data-val"));
			if (isNaN(rotate_init_val)) {
				rotate_init_val = 0;
			}

			const leftSide = 270; // поворот влево
			const rightSide = 90; // поворот вправо

			const targetSide = side === "left" ? leftSide : rightSide;

			var deg = (rotate_val + targetSide) % 360;
			var rotate = (360 + deg - rotate_init_val) % 360;
			$("input[name^='rotate']", attfile).val(deg);
			pic.style.transform = "rotate(" + rotate + "deg)";
			updateAlpineStorage(inp);
		},
		/**
		 * Удаление файла из списка.
		 * Если файл новый (только что загружен, класс "new") — удаляет DOM-элемент полностью.
		 * Если файл существующий (уже был на сервере) — очищает скрытый input и добавляет класс "removed",
		 * чтобы бэкенд понял, что файл нужно отвязать.
		 * 
		 * @param {HTMLElement} inp - Кнопка удаления (span.del), по которой кликнули.
		 */
		fileDel(inp) {
			if (typeof protocolsAction !== 'undefined') { // замена протоколов
				const tr = findParentByClassName(inp, 'sf_container');
				if (tr) {
					protocolsAction(tr);
				}
			}

			var lotParent = findParentByClassName(inp, 'gray-block');
			var lotNumber = $(lotParent).attr("data-lotnum");

			var attfile = findParentByClassName(inp, 'attfile');

			if (typeof fileDelMod !== 'undefined') { // editCompetitions1
				fileDelMod(attfile);
			}
			
			if ($(attfile).hasClass("new")) {
				var filelist = findParentByClassName(inp, 'filelist');
				$(attfile).remove();
				fileReindex(filelist);
			} else {
				$("input[type=hidden]", attfile).val('');
				$(attfile).addClass('removed');
			}
			photoLoaded(lotNumber);

			if (window?.FUNCS?.DKP_Docs) { // дкп в черновиках торгов
				window.FUNCS.DKP_Docs.collectSelectedCats();
			}
		},
		
		/**
		 * Обработчик клика на кнопку "Загрузить".
		 * Если пользователь уже ознакомлен с требованиями (или кнопка имеет data-skip-fileinfo), 
		 * сразу открывает диалог выбора файлов. Иначе показывает модальное окно с требованиями.
		 * 
		 * @param {HTMLElement} btn - Кнопка, по которой кликнули.
		 * @param {Event} event - Событие клика.
		 * @returns {boolean|undefined} false для предотвращения дефолтного поведения.
		 */
		fileOpen(btn, event) {
			//	console.log("FK.fileOpen", btn, event);
			event.stopPropagation(); // остановка всех текущих JS событий
			event.preventDefault();  // остановка дефолтного события для текущего элемента - клик для <a> тега
			var parent = $(btn).parents('.fileform');
			if (localStorage.getItem('loadFileAcceptHide') || $(btn).attr("data-skip-fileinfo")) {
				$("input[type=file]", parent).val('').click();
				return;
			}
			MoK.showFileAccept(parent);
			return false;
		},
	};

	// то, что будет доступно снаружи
	const publicAPI = {
		...FK,
		...FileUploadKit, // - нужно доработать
		...filesForm,
		...videoKit,
	};

	return publicAPI;
})();
